import React, { useEffect, useState } from "react";
import AccountsMenu from './AccountsMenu';
import { NavLink } from 'react-router-dom';
import config from "../../Config";
import axios from "axios";
import { Spinner } from "react-bootstrap";
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { scrollToTop } from '../Shared/ScrollOnTop';

function AddNewAccount(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    const [FYear, setFYear] = useState(localStorage.getItem("DefaultFYear"));
    const [Accounts, setAccounts] = useState([]);
    const [loading, setLoading] = useState(false);

    const [FirstAccountId, setFirstAccountId] = useState(0);
    const [SecondAccountId, setSecondAccountId] = useState(0);

    const [FirstLevelCode, setFirstLevelCode] = useState("");
    const [SecondLevelCode, setSecondLevelCode] = useState("");
    const [ThirdLevelCode, setThirdLevelCode] = useState("");

    const [AccountCode, setAccountCode] = useState("");
    const [ParentAccountCode, setParentAccountCode] = useState("");

    const [AccountDetail, setAccountDetail] = useState("");
    const [AccountRemarks, setAccountRemarks] = useState("");

    const [Level1Status, setLevel1Status] = useState(false);
    const [Level2Status, setLevel2Status] = useState(true);
    const [Level3Status, setLevel3Status] = useState(true);

    // What account level needs to be added.
    const [AccountLevel, setAccountLevel] = useState(1);

    const loadAccounts = () => {
        setLoading(true);
        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            FYear: FYear,
            pageNo: 1,
            pageSize: 1000,
        };

        var api_config = {
            method: 'post',
            url: config.base_url + 'Accounts/GetAccountsByYear',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };

        axios(api_config)
            .then(function (response) {
                setAccounts(response.data.ListofRecords || []);
                setLoading(false);
            })
            .catch(function (error) {
                setLoading(false);
            });
    };

    useEffect(() => {
        loadAccounts();
    }, [FYear]);

    const getNextLevelCode = (level, parentId, parentCode) => {
        let siblings = Accounts.filter(item => item.iLevel == level);
        if (level > 1 && parentId > 0) {
            siblings = siblings.filter(item => item.pAccountID == parentId);
        }
        let maxSeg = 0;
        siblings.forEach(item => {
            const code = item.Account_code || "";
            const parts = code.split("-");
            const last = parts[parts.length - 1];
            const num = parseInt(last, 10);
            if (!Number.isNaN(num) && num > maxSeg) {
                maxSeg = num;
            }
        });
        const nextSeg = (maxSeg + 1).toString().padStart(2, "0");
        if (level === 1) {
            return nextSeg;
        }
        if (parentCode) {
            return `${parentCode}-${nextSeg}`;
        }
        return "";
    };

    useEffect(() => {
        if (!loading) {
            const nextFirst = getNextLevelCode(1, 0, "");
            setFirstLevelCode(nextFirst);
            if (AccountLevel === 1) {
                setAccountCode(nextFirst);
                setParentAccountCode("");
            }
        }
    }, [Accounts]);


    const renderAccountsFirst = () => {
        if (Accounts.length > 0) {
            let level1 = Accounts.filter(item => item.iLevel == 1);

            return (

                level1.map((item, index) => {
                    return (
                        loading ?
                            <option selected disabled>Loading...</option>
                            :
                            <option value={item.ID} data-code={item.Account_code} key={index}>{item.Account_desc}</option>
                    )
                })
            );
        }
    }

    const renderAccountsSecond = () => {
        if (Accounts.length > 0) {
            let level2 = Accounts.filter(item => item.iLevel == 2 && item.pAccountID == FirstAccountId);
            return (

                level2.map((item, index) => {
                    return (
                        <option value={item.ID} data-code={item.Account_code} key={index}>{item.Account_desc}</option>
                    )
                })
            );
        }
    }


    const renderAccountsThird = () => {
        if (Accounts.length > 0) {
            let level1 = Accounts.filter(item => item.iLevel == 3 && item.pAccountID == SecondAccountId);
            return (

                level1.map((item, index) => {
                    return (
                        <option value={item.ID} data-code={item.Account_code} key={index}>{item.Account_desc}</option>
                    )
                })
            );
        }
    }

    const handleFirstChange = (e) => {
        const newFirstId = parseInt(e.target.value, 10) || 0;
        setFirstAccountId(newFirstId);
        setSecondAccountId(0);
        const selectedOptionCode = e.target.options[e.target.selectedIndex].dataset.code || "";
        const firstcode = selectedOptionCode.toString().padStart(2, "0");
        setFirstLevelCode(firstcode);

        if (newFirstId === 0) {
            setAccountLevel(1);
            const nextFirst = getNextLevelCode(1, 0, "");
            setAccountCode(nextFirst);
            setParentAccountCode("");
            setSecondLevelCode("");
            setThirdLevelCode("");
            setLevel1Status(false);
            setLevel2Status(true);
            setLevel3Status(true);
        } else {
            setAccountLevel(2);
            const nextSecond = getNextLevelCode(2, newFirstId, firstcode);
            setSecondLevelCode(nextSecond);
            setAccountCode(nextSecond);
            setParentAccountCode(firstcode);
            setThirdLevelCode("");
            setLevel1Status(true);
            setLevel2Status(false);
            setLevel3Status(true);
        }

        setAccountDetail("");
        setAccountRemarks("");

    }

    const handleSecondChange = (e) => {
        const newSecondId = parseInt(e.target.value, 10) || 0;
        setSecondAccountId(newSecondId);
        const selectedOptionCode = e.target.options[e.target.selectedIndex].dataset.code || "";
        setSecondLevelCode(selectedOptionCode);

        if (newSecondId === 0) {
            setAccountLevel(2);
            const parent = Accounts.find(a => a.ID == FirstAccountId);
            const parentCode = parent ? parent.Account_code : "";
            const nextSecond = getNextLevelCode(2, FirstAccountId, parentCode);
            setAccountCode(nextSecond);
            setParentAccountCode(parentCode || "");
            setThirdLevelCode("");
            setLevel1Status(true);
            setLevel2Status(false);
            setLevel3Status(true);
        } else {
            setAccountLevel(3);
            const nextThird = getNextLevelCode(3, newSecondId, selectedOptionCode);
            setThirdLevelCode(nextThird);
            setAccountCode(nextThird);
            setParentAccountCode(selectedOptionCode);
            setLevel1Status(true);
            setLevel2Status(true);
            setLevel3Status(false);
        }

        setAccountDetail("");
        setAccountRemarks("");

    }

    const handleThirdChange = (e) => {
        // No-op for creation, third level dropdown is informational
        return;

    }


    const handleSaveAccount = () => {


        if(AccountDetail == "") {
            toast.error('Please enter account details', {
                position: toast.POSITION.TOP_RIGHT
            });
        }
        else {
            if (AccountLevel === 2 && FirstAccountId == 0) {
                toast.error('Please select a 1st level account first.', {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
            if (AccountLevel === 3 && (FirstAccountId == 0 || SecondAccountId == 0)) {
                toast.error('Please select 1st and 2nd level accounts first.', {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
            const data = {
                UserID: UserID,
                AccessKey: AccessKey,
                FirstLevelID: AccountLevel >= 2 ? FirstAccountId : 0,
                SecondLevelID: AccountLevel === 3 ? SecondAccountId : 0,
                Account_code: AccountCode,
                ParentAccountCode: ParentAccountCode,
                Account_desc: AccountDetail,
                Remarks: AccountRemarks,
                Year: FYear
            }

            //console.log(data);
    
            var api_config = {
                method: 'post',
                url: config.base_url + 'Accounts/AddNewAccount',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            axios(api_config)
            .then(function (response) {
                if (response.data.status_code == 1) {
                    toast.success(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                    loadAccounts();
                }
                else {
                    toast.error(response.data.status_message, {
                        position: toast.POSITION.TOP_RIGHT
                    });
                }

                setLoading(false);


            })
            .catch(function (error) {
                setLoading(false);
                toast.error('Network Error..', {
                    position: toast.POSITION.TOP_RIGHT
                });
            });
        }
        
    }

    return (
        <>
            <AccountsMenu />
            <ToastContainer />
            <div className="container body-content">

                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to="/Dashboard">Dashboard</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to="/Accounts/AccountsDashboard">Accounts</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Add New Account</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Add / Update Account</div>
                            </div>
                            <div className="col-md-6">
                                <div className="page-right-actions">
                                    <NavLink to="/Accounts/ManageAccounts" className="button button-white button-icon">
                                        Manage Account
                                        <i className="ri-add-line"></i>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="page-content">
                    <div className="container">
                        <div className="card">
                            <div className="card-body p-4">

                                {
                                    loading ?
                                        <div className='text-center'>
                                            <Spinner animation="border" role="status"></Spinner>
                                            
                                        </div>
                                        :
                                        <>
                                        <div className="row align-items-center mb-3">
                                    <div className="col-md-2">
                                        <h5>1<sup>st</sup> Level</h5>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <div className="form-group mb-2">
                                                    <label>Select 1st Level</label>
                                                    <select id="levelOne" className="form-select" required value={FirstAccountId} onChange={(e) => handleFirstChange(e)}>
                                                        <option value="0" data-code="0">Create 1st Level</option>
                                                        {renderAccountsFirst()}

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-2">
                                                    <label>Account Detail</label>
                                                    <input type="text" className="form-control" value={AccountDetail} onChange={(e) => setAccountDetail(e.target.value)} disabled={Level1Status} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Remarks</label>
                                                    <input type="text" className="form-control" value={AccountRemarks} onChange={(e) => setAccountRemarks(e.target.value)}  disabled={Level1Status} />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                {FirstLevelCode || "-"}
                                            </div>
                                        </div>


                                    </div>

                                </div>
                                <div className="row align-items-center mb-3">
                                    <div className="col-md-2">
                                        <h5>2<sup>nd</sup> Level</h5>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <div className="form-group mb-2">
                                                    <label>Select 2nd Level</label>
                                                    <select id="levelTwo" className="form-select" required value={SecondAccountId} onChange={(e) => handleSecondChange(e)} disabled={FirstAccountId == 0}>
                                                        <option value="0" data-code="0">Create 2nd Level</option>
                                                        {renderAccountsSecond()}

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-2">
                                                    <label>Account Detail</label>
                                                    <input type="text" className="form-control" value={AccountDetail} onChange={(e) => setAccountDetail(e.target.value)} disabled={Level2Status} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Remarks</label>
                                                    <input type="text" className="form-control" value={AccountRemarks} onChange={(e) => setAccountRemarks(e.target.value)} disabled={Level2Status} />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                {SecondLevelCode || "-"}
                                            </div>
                                        </div>


                                    </div>

                                </div>
                                <div className="row align-items-center">
                                    <div className="col-md-2">
                                        <h5>3<sup>rd</sup> Level</h5>
                                    </div>
                                    <div className="col-md-10">
                                        <div className="row align-items-center">
                                            <div className="col-md-3">
                                                <div className="form-group mb-2">
                                                    <label>Select 3rd Level</label>
                                                    <select id="levelThree" className="form-select" required onChange={(e) => handleThirdChange(e)} disabled={SecondAccountId == 0}>
                                                        <option value="0" data-code="0">Create 3rd Level</option>
                                                        {
                                                            renderAccountsThird()

                                                        }

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group mb-2">
                                                    <label>Account Detail</label>
                                                    <input type="text" className="form-control" value={AccountDetail} onChange={(e) => setAccountDetail(e.target.value)} disabled={Level3Status} />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Remarks</label>
                                                    <input type="text" className="form-control" value={AccountRemarks} onChange={(e) => setAccountRemarks(e.target.value)}  disabled={Level3Status} />
                                                </div>
                                            </div>
                                            <div className="col-md-2">
                                                {ThirdLevelCode || "-"}
                                            </div>
                                        </div>


                                    </div>

                                </div>
                                <div className="mt-3">
                                     <button className="button button-primary" onClick={handleSaveAccount}>Save Account</button>
                                </div>
                                        </>
                                }

                                

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}

export default AddNewAccount;